import colors from 'styles/theme/colors';

const PhoneNumberIcon = ({
  width = 16,
  height = 16,
  color = colors.black100,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={width} height={height} viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M10.5265 14.9267L10.5345 14.9314C11.2426 15.3822 12.0832 15.578 12.9176 15.4865C13.752 15.395 14.5303 15.0216 15.1238 14.4281L15.6398 13.9121C15.8703 13.6813 15.9997 13.3685 15.9997 13.0424C15.9997 12.7163 15.8703 12.4035 15.6398 12.1727L13.4658 10.0001C13.2351 9.76962 12.9223 9.64017 12.5961 9.64017C12.27 9.64017 11.9572 9.76962 11.7265 10.0001C11.6124 10.1143 11.4769 10.205 11.3277 10.2668C11.1785 10.3287 11.0186 10.3605 10.8571 10.3605C10.6957 10.3605 10.5358 10.3287 10.3866 10.2668C10.2374 10.205 10.1019 10.1143 9.98781 10.0001L6.50914 6.52074C6.27868 6.28999 6.14924 5.9772 6.14924 5.65108C6.14924 5.32495 6.27868 5.01216 6.50914 4.78141C6.6234 4.6673 6.71403 4.53178 6.77588 4.38262C6.83772 4.23345 6.86955 4.07356 6.86955 3.91208C6.86955 3.7506 6.83772 3.59071 6.77588 3.44154C6.71403 3.29237 6.6234 3.15686 6.50914 3.04274L4.33581 0.866744C4.10506 0.636283 3.79227 0.506836 3.46614 0.506836C3.14002 0.506836 2.82723 0.636283 2.59648 0.866744L2.08048 1.38274C1.48703 1.97633 1.11369 2.75451 1.02206 3.58885C0.93043 4.42319 1.12599 5.26385 1.57648 5.97208L1.58181 5.98008C3.96409 9.50663 7.00046 12.5437 10.5265 14.9267Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default PhoneNumberIcon;
